import { statusOptions } from "@/features/private-room/contracts/list/utils/private-office-contract";
import { apiWobaBackend } from "../api-woba-backend";
import {
  CancelPrivateOfficeContractDataParams,
  CancelPrivateOfficeContractResponse,
  Pagination,
  PrivateOfficeContract,
  ContractHistoryEntry,
} from "./types";

export const privateOfficeContractsService = {
  async listPrivateOfficeContracts({
    company,
    space,
    poContractId,
    poContractIdList,
    startDate,
    endDate,
    status,
    take,
    page,
    allData,
    orderBy,
  }: {
    company?: number | string;
    space?: number | string;
    poContractId?: string;
    poContractIdList?: string[];
    startDate?: string;
    endDate?: string;
    status?: string;
    take?: number;
    page?: number;
    allData?: boolean;
    orderBy?: string;
  }): Promise<{ contracts: PrivateOfficeContract[]; pagination: Pagination }> {
    const search = new URLSearchParams();

    if (company) {
      search.append("companyId", company.toString());
    }

    if (space) {
      search.append("spaceId", space.toString());
    }

    if (poContractId) {
      search.append("poContractId[]", poContractId);
    }

    if (poContractIdList && poContractIdList.length > 0) {
      poContractIdList.forEach((id) => {
        search.append("poContractId[]", id);
      });
    }

    if (startDate) {
      search.append("startDate", startDate);
    }

    if (endDate) {
      search.append("endDate", endDate);
    }
    if (status) {
      search.append(
        "status",
        statusOptions.find((option) => option.id === Number(status))?.slug ||
          "",
      );
    }

    if (take) {
      search.append("take", take?.toString());
    }

    if (page) {
      search.append("page", page?.toString());
    }

    if (allData) {
      search.append("allData", allData?.toString());
    }

    if (orderBy) {
      search.append("orderBy", orderBy);
    }

    const response = await apiWobaBackend.get(
      `/private-offices/contracts?${search.toString()}`,
    );

    return response.data;
  },

  async getContractHistory(
    contractId: number,
  ): Promise<ContractHistoryEntry[]> {
    const response = await apiWobaBackend.get(
      `/private-offices/contracts/${contractId}/histories`,
    );
    return response.data;
  },

  async getPrivateOfficeContractById(
    id: number,
  ): Promise<PrivateOfficeContract> {
    const response = await apiWobaBackend.get(
      `/private-offices/contracts/${id}`,
    );

    return response.data;
  },

  async cancelPrivateOfficeContract({
    id,
    cancellationDate,
    cancellationReason,
    noticeStartDate,
  }: CancelPrivateOfficeContractDataParams): Promise<CancelPrivateOfficeContractResponse> {
    const response = await apiWobaBackend.patch(
      `/private-offices/contracts/${id}/cancel`,
      {
        cancelledAt: cancellationDate,
        cancellationReason,
        noticeStartDate,
      },
    );

    return response.data;
  },
};
